import { customerApi } from "../../utils/apiConfig";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

export const createPublicKaizenSuggestion = (payload) =>
  customerApi.post("/kaizen-suggestions/public", payload);

export const getKaizenSuggestions = (params = {}) =>
  customerApi.get("/kaizen-suggestions", {
    ...authHeaders(),
    params,
  });
